import { render, staticRenderFns } from "./WithoutNoticeOrAttendance.vue?vue&type=template&id=118cfb67"
import script from "./WithoutNoticeOrAttendance.vue?vue&type=script&lang=ts"
export * from "./WithoutNoticeOrAttendance.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports